import { createGlobalStyle } from 'styled-components'

const BaselineStyle = createGlobalStyle`
  * {
    border-style: solid;
  }

  input {
    color: #000;
    background-color: #FFF;
  }
`

export default BaselineStyle
